<span class="flex-body ellipsis-menu">
  <p-menu #menu appendTo="body" [popup]="true" class="text-left menu-container" [model]="menuItems"></p-menu>
  <a>
    <i *ngIf="!disabled" class="ei ei-kebab-more" (click)="menu.toggle($event)"></i>
    <i *ngIf="disabled" class="ei ei-kebab-more disable"></i>
  </a>
</span>
